import { MediaFile, AudioOptionInput, Program } from 'models';
import { MediaType, ProgramFormFields } from 'models/forms';
import { convertToMediaFile } from 'helpers/programs';

export const initialFileInput: MediaFile = { name: '', file: '' };

export const initialOption: AudioOptionInput = {
  audioTrack: { ...initialFileInput },
  padsTrack: { ...initialFileInput },
  duration: null,
};

const initialValues: ProgramFormFields = {
  name: '',
  order: 0,
  description: '',
  imageURL: '',
  isSubscriptionRequired: false,
  enabled: false,
  options: [{ ...initialOption, duration: 600 }],
  video: null,
};

export const getInitialValues = (program?: Program): ProgramFormFields => {
  let values = { ...initialValues };
  if (program) {
    const video = convertToMediaFile(program.videoURL, MediaType.VIDEO);
    const options = program.options.map((option) => ({
      audioTrack: convertToMediaFile(option.audioTrack, MediaType.AUDIO),
      padsTrack: option.padsTrack
        ? convertToMediaFile(option.padsTrack, MediaType.AUDIO)
        : { ...initialFileInput },
      duration: option.duration,
    }));
    values = {
      name: program.name,
      description: program.description,
      order: program.order,
      enabled: program.enabled,
      isSubscriptionRequired: program.isSubscriptionRequired,
      imageURL: program.imageURL,
      options,
      video,
    };
  }
  return values;
};
